import { render, staticRenderFns } from "./Xtract.vue?vue&type=template&id=523628e0&scoped=true&"
import script from "./Xtract.vue?vue&type=script&lang=js&"
export * from "./Xtract.vue?vue&type=script&lang=js&"
import style0 from "./Xtract.vue?vue&type=style&index=0&id=523628e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523628e0",
  null
  
)

export default component.exports